"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var basic_table_component_1 = require("../../../basic-component/basic-table.component");
function showEditModal() {
    $("#schemaBuilderModal").modal({ backdrop: 'static', keyboard: false });
}
function hideEditModal() {
    $("#schemaBuilderModal").modal('hide');
}
function showDeleteModal() {
    $("#deleteSchemaModal").modal('show');
}
var SchemaModalsComponent = /** @class */ (function () {
    function SchemaModalsComponent($scope) {
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $scope.$on('schemaModal:new', function () { return ctrl.initNew(); });
        $scope.$on('schemaModal:edit', function () { return ctrl.initEdit(); });
        $scope.$on('schemaModal:delete', showDeleteModal);
        $scope.$on('universal.schema:cancel', hideEditModal);
        $scope.$on('universal.schema:done', hideEditModal);
    }
    SchemaModalsComponent.prototype.initNew = function () {
        this.$scope.$broadcast('universal.schema:init', {
            selectedTreeNode: this.currentNode,
            isAdmin: this.isAdmin,
            isPortfolioAdmin: this.isPortfolioAdmin
        });
        showEditModal();
    };
    SchemaModalsComponent.prototype.initEdit = function () {
        this.$scope.$broadcast('universal.schema:init', {
            selectedTreeNode: this.currentNode,
            isAdmin: this.isAdmin,
            isPortfolioAdmin: this.isPortfolioAdmin,
            schema: this.schema
        });
        showEditModal();
    };
    SchemaModalsComponent.prototype.deleteSchema = function () {
        var ctrl = this;
        ctrl.smartorgApi.deleteUnivSchemaFromRoot(ctrl.currentNode._id, ctrl.schema.id).then(function (res) {
            if (res.status == 0) {
                ctrl.showAlert('success', 'Success!', res.message);
                ctrl.$scope.$emit('workbench:reloadroot');
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (ex) {
            ctrl.showAlert('danger', 'Error!', ex.message);
        });
    };
    SchemaModalsComponent = __decorate([
        (0, basic_table_component_1.Component)({
            bindings: {
                smartorgApi: '=',
                schema: '<',
                currentNode: '<',
                isAdmin: '<',
                isPortfolioAdmin: '<'
            },
            template: require('./schema-modals.component.html')
        }),
        __metadata("design:paramtypes", [Object])
    ], SchemaModalsComponent);
    return SchemaModalsComponent;
}());
angular.module('smartorg.r6.acts.universal.schemaModals', []).component('schemaModals', SchemaModalsComponent);
module.exports = 'smartorg.r6.acts.universal.schemaModals';
//# sourceMappingURL=schema-modals.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/schema-modals/schema-modals.component.js